import { Button, Grid, Typography } from "@material-ui/core";
import React, { useState } from "react";

import { SearchTextField } from "@/controls/quick-filter-textfield/SearchTextField";
import { useGridStyles } from "@/pages/laboratory/styles/gridStyles";
import { AgGridReact } from "ag-grid-react";
import { useGridDefinitions } from "../../../../../controls/ag-grid/components/GridDefinitions";
import { CatalogSection } from "../../../models/CatalogSection";
import { CreateSection } from "./CreateSection";
import { EditSection } from "./EditSection";
import { useTableData } from "./hooks";

type Props = {
	getCatalogSectionsFromAPI: Function;
	isLoading: boolean;
};

export const TableSection = ({
	getCatalogSectionsFromAPI,
	isLoading,
}: Props) => {
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [idSection, setIdSection] = useState<number | null>(null);
	const [quickFilterText, setQuickFilterText] = useState("");
	const { rows, columns, defaultColDef } = useTableData({});
	const { columnDefaults, columnTypes } = useGridDefinitions({
		OnEdit: (data: CatalogSection) => {
			setShowEditModal(!showEditModal);
			setIdSection(data.SectionId);
		},
	});

	const classes = useGridStyles();
	return (
		<>
			<Grid item xs={12} container justifyContent="center" spacing={1}>
				<Grid item md={12} xs={12}>
					<Typography variant="h5" style={{ fontWeight: 600 }}>
						Sections
					</Typography>
				</Grid>

				<Grid
					item
					xs={12}
					container
					justifyContent="flex-end"
					alignContent="center"
				>
					<Grid item xs={12} style={{ marginBottom: 10 }}>
						<SearchTextField
							value={quickFilterText}
							onChange={(text) => setQuickFilterText(text)}
							label="Search sections"
						/>
					</Grid>
					<Grid
						item
						md={12}
						xs={12}
						style={{ height: "68vh" }}
						className={classes.borderAgGridTable}
					>
						<div style={{ height: "100%", width: "100%" }}>
							<AgGridReact
								rowData={rows || []}
								columnDefs={columns}
								getRowId={(params) => params.data.SectionId}
								columnTypes={columnTypes}
								suppressContextMenu
								onRowDoubleClicked={(params) => {
									setIdSection(params.data.SectionId);
									setShowEditModal(true);
								}}
								rowSelection="single"
								quickFilterText={quickFilterText}
							/>
						</div>
					</Grid>

					<Grid item md={"auto"} xs={12} style={{ marginTop: 10 }}>
						<Button
							variant="contained"
							color="primary"
							fullWidth
							style={{ minWidth: 250 }}
							onClick={() => setShowCreateModal(!showCreateModal)}
						>
							NEW SECTION
						</Button>
					</Grid>
				</Grid>
			</Grid>

			<CreateSection
				show={showCreateModal}
				onHide={() => setShowCreateModal(false)}
				refreshData={getCatalogSectionsFromAPI}
			/>
			<EditSection
				show={showEditModal}
				onHide={(shouldUpdate?: boolean) => {
					setShowEditModal(false);
					setIdSection(null);
					if (shouldUpdate) getCatalogSectionsFromAPI();
				}}
				SectionId={idSection}
			/>
		</>
	);
};
